import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const empty = { title: "", category: "Campaigns", image_url: "" };
const CATS = ["Campaigns", "Events", "Meetings"];

export default function GalleryAdmin() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/gallery").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!form.image_url) return toast.error("Image URL required");
    try {
      await api.post("/admin/gallery", form);
      toast.success("Added"); setForm(empty); load();
    } catch (err) { toast.error("Failed"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/gallery/${id}`);
    toast.success("Deleted"); load();
  };

  return (
    <div data-testid="admin-gallery" className="space-y-8">
      <header><div className="label-eyebrow mb-2">Manage</div>
        <h1 className="font-display text-4xl text-[hsl(var(--primary))]">Gallery Images</h1></header>

      <form onSubmit={save} className="bg-white border border-[hsl(var(--border-c))] p-6 grid sm:grid-cols-3 gap-4 items-end">
        <div className="sm:col-span-2"><Label>Image URL *</Label><Input required value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} data-testid="gal-url" placeholder="https://..." /></div>
        <div><Label>Category</Label>
          <Select value={form.category} onValueChange={(v) => setForm({ ...form, category: v })}>
            <SelectTrigger data-testid="gal-category"><SelectValue /></SelectTrigger>
            <SelectContent>{CATS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="sm:col-span-2"><Label>Title (optional)</Label><Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
        <Button type="submit" data-testid="gal-add" className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary-hover))] rounded-none uppercase tracking-widest">
          <Plus size={14} className="mr-2" /> Add
        </Button>
      </form>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {list.map((g) => (
          <div key={g.id} className="relative group">
            <img src={g.image_url} alt={g.title} className="w-full aspect-square object-cover" loading="lazy" />
            <div className="absolute top-2 left-2 bg-[hsl(var(--primary))] text-white px-2 py-1 text-[10px] uppercase tracking-widest">{g.category}</div>
            <button onClick={() => remove(g.id)} data-testid={`gal-del-${g.id}`}
              className="absolute top-2 right-2 bg-white/90 p-2 opacity-0 group-hover:opacity-100 transition-opacity">
              <Trash2 size={14} className="text-[hsl(var(--accent))]" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
